export default __webpack_public_path__ + "static/media/112-laos.c581bd4a.svg";